export const EXPIRATION_TIME_IN_MILLISECONDS = 1000 * 60 * 60 * 24 * 365 * 1;
